import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Output, EventEmitter } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
declare const $: any;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css', './homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  @Output() change = new EventEmitter();
  name: any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;


  constructor(private router: Router, media: MediaMatcher, changeDetectorRef: ChangeDetectorRef,) {
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngOnInit() {
    this.name = localStorage.userName;
    this.storedTheme;
  }
  Logout() {
    localStorage.clear();
    this.change.emit(true);
    // this.router.navigate(['/login']);
    this.router.navigate(['/homepages/index']);
  }

  ngAfterViewInit() {
    $('#menu1').metisMenu();
  }

  isLargeScreen() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 720) {
      return true;
    } else {
      return false;
    }
  }

  storedTheme: string = localStorage.getItem('theme-color');
  setTheme(theme) {
    localStorage.setItem('theme-color', theme);
    this.storedTheme = localStorage.getItem('theme-color');
  }

}



// WEBPACK FOOTER //
// ./src/app/homepage/homepage.component.ts